import React from 'react';
import styled from 'styled-components/macro';
import { PiecesListItem } from 'lib/modelBuilder/utils/cabinetPiecesList';
import { KewloxPieceType } from 'lib/modelBuilder/pieces/CustomPiece';
import { useTranslation } from 'react-i18next';

interface Props {
  item: PiecesListItem<KewloxPieceType>;
}

function PieceListItem({ item }: Props) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center">
      <PieceListItemDescription
        className={`${item.isCustom() ? 'text-purple-dark font-medium' : ''} ${
          item.description().length > 18 ? 'text-sm' : 'text-normal'
        }`}
      >
        {item.description()}
      </PieceListItemDescription>
      {item.colorHexa && item.colorName && (
        <ColorIndicator
          color={item.colorHexa}
          className="w-6 h-5 mx-1 border border-gray-700 text-indigo-dark"
          data-tip={item.colorName}
          data-for="colorInfo"
        />
      )}
      <span className="font-semibold mx-1">{item.getTotalPrice()}€</span>
      <span className="font-normal text-sm mx-1">
        {process.env.NODE_ENV !== 'production' && (
          <>{parseFloat(item.totalWeight) / item.quantity} kg </>
        )}
        ({item.totalPriceTaxIncl}€ {t('TTC')})
      </span>
    </div>
  );
}

export default PieceListItem;

const ColorIndicator = styled.div<{ color: string }>`
  background-color: ${props => props.color};
`;

const PieceListItemDescription = styled.div<{ custom?: boolean }>``;
